import * as React from "react";
const SvgCreateAccountImg = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 150, height: 132, fill: "none", viewBox: "0 0 150 132", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "#a5beff", strokeLinecap: "round", strokeLinejoin: "round", d: "M126 88.511 75 118.5 24 88.511 75 60z", style: {
  stroke: "#a5beff",
  stroke: "color(display-p3 .6458 .745 1)",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { stroke: "#e1ebff", strokeLinecap: "round", strokeLinejoin: "round", d: "M137.5 88.347 75 125 12.5 88.347 75 53.5z", style: {
  stroke: "#e1ebff",
  stroke: "color(display-p3 .8833 .923 1)",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { stroke: "#e1ebff", strokeLinecap: "round", strokeLinejoin: "round", d: "M149 88.183 75 131.5 1 88.183 75 47z", style: {
  stroke: "#e1ebff",
  stroke: "color(display-p3 .8833 .923 1)",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#577ee4", stroke: "#577ee4", strokeLinecap: "round", strokeLinejoin: "round", d: "M115.5 88.663 75 112.5 34.5 88.663 75 66z", style: {
  fill: "#577ee4",
  fill: "color(display-p3 .3397 .4954 .8958)",
  fillOpacity: 1,
  stroke: "#577ee4",
  stroke: "color(display-p3 .3397 .4954 .8958)",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#e1ebff", stroke: "#577ee4", strokeLinecap: "round", strokeLinejoin: "round", d: "M75.146 112.5V77.152l30.45-17.141v34.496zm0 0V77.152l-30.45-17.141v34.496z", style: {
  fill: "#e1ebff",
  fill: "color(display-p3 .8833 .923 1)",
  fillOpacity: 1,
  stroke: "#577ee4",
  stroke: "color(display-p3 .3397 .4954 .8958)",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#577ee4", stroke: "#577ee4", strokeLinecap: "round", strokeLinejoin: "round", d: "m105.596 60.01-30.45 17.142-30.45-17.141 30.45-17.993z", style: {
  fill: "#577ee4",
  fill: "color(display-p3 .3397 .4954 .8958)",
  fillOpacity: 1,
  stroke: "#577ee4",
  stroke: "color(display-p3 .3397 .4954 .8958)",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#e1ebff", stroke: "#577ee4", strokeLinecap: "round", strokeLinejoin: "round", d: "M60.24 33.5 29.79 50.642l14.906 9.37 30.45-17.993zm45.356 26.51 15.864-9.155-30.45-17.142-15.864 8.305z", style: {
  fill: "#e1ebff",
  fill: "color(display-p3 .8833 .923 1)",
  fillOpacity: 1,
  stroke: "#577ee4",
  stroke: "color(display-p3 .3397 .4954 .8958)",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#a5beff", stroke: "#577ee4", strokeLinecap: "round", strokeLinejoin: "round", d: "m95.109 100.703-9.53 5.631V71.279l9.53-5.358zm-39.926 0 9.529 5.631V71.279l-9.529-5.358z", style: {
  fill: "#a5beff",
  fill: "color(display-p3 .6458 .745 1)",
  fillOpacity: 1,
  stroke: "#577ee4",
  stroke: "color(display-p3 .3397 .4954 .8958)",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#e1ebff", stroke: "#577ee4", strokeLinecap: "round", strokeLinejoin: "round", d: "m60.347 86.415 14.799-9.263-30.45-17.141-14.8 8.41zm45.249-26.405-30.45 17.142 15.118 9.05 30.451-17.993z", style: {
  fill: "#e1ebff",
  fill: "color(display-p3 .8833 .923 1)",
  fillOpacity: 1,
  stroke: "#577ee4",
  stroke: "color(display-p3 .3397 .4954 .8958)",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("mask", { id: "a", width: 265, height: 75, x: -59, y: 2, maskUnits: "userSpaceOnUse", style: {
  maskType: "alpha"
} }, /* @__PURE__ */ React.createElement("path", { fill: "#2c1a4f", d: "M-58.768 2.141H205.75L182 57.415 104.75 60l-29.5 16.75L45 60l-82.75 1.502z", style: {
  fill: "#2c1a4f",
  fill: "color(display-p3 .173 .1028 .3083)",
  fillOpacity: 1
} })), /* @__PURE__ */ React.createElement("g", { mask: "url(#a)" }, /* @__PURE__ */ React.createElement("path", { fill: "#a5beff", d: "m76.849 54.698-20.071-26.2a1 1 0 0 0-1.399-.188l-11.374 8.643-7.687 5.957a1 1 0 0 0-.181 1.398L56.209 70.51a1 1 0 0 0 1.402.185L76.663 56.1a1 1 0 0 0 .186-1.402", style: {
  fill: "#a5beff",
  fill: "color(display-p3 .6458 .745 1)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#577ee4", d: "m36.318 42.91-.306-.395zm7.687-5.957-.303-.399-.003.003zm11.374-8.643.303.398zm1.002.492 20.07 26.2.794-.608-20.07-26.2zm19.978 26.901L57.307 70.298l.608.794 19.052-14.595zM56.606 70.205l-20.072-26.2-.794.607 20.072 26.202zm-19.981-26.9 7.686-5.957-.612-.79-7.687 5.957zm7.682-5.954 11.374-8.643-.604-.796-11.374 8.642zm-7.773 6.653a.5.5 0 0 1 .09-.699l-.612-.79a1.5 1.5 0 0 0-.272 2.097zm20.773 26.294a.5.5 0 0 1-.701-.093l-.794.609a1.5 1.5 0 0 0 2.103.278zM76.45 55.002a.5.5 0 0 1-.092.701l.608.794a1.5 1.5 0 0 0 .278-2.103zM57.176 28.194a1.5 1.5 0 0 0-2.098-.282l.605.796a.5.5 0 0 1 .699.094z", style: {
  fill: "#577ee4",
  fill: "color(display-p3 .3397 .4954 .8958)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#a5beff", stroke: "#577ee4", strokeLinecap: "round", strokeLinejoin: "round", d: "M87.383 19.53 69.217 46.422a2.5 2.5 0 0 0 .673 3.47L96.783 68.06a2.5 2.5 0 0 0 3.471-.673l18.166-26.893a2.5 2.5 0 0 0-.672-3.471l-13.447-9.083-13.447-9.083a2.5 2.5 0 0 0-3.47.672", style: {
  fill: "#a5beff",
  fill: "color(display-p3 .6458 .745 1)",
  fillOpacity: 1,
  stroke: "#577ee4",
  stroke: "color(display-p3 .3397 .4954 .8958)",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("mask", { id: "b", width: 52, height: 52, x: 68, y: 17, maskUnits: "userSpaceOnUse", style: {
  maskType: "alpha"
} }, /* @__PURE__ */ React.createElement("path", { fill: "#e1ebff", stroke: "#2c1a4f", strokeLinecap: "round", strokeLinejoin: "round", d: "M87.383 19.53 69.217 46.422a2.5 2.5 0 0 0 .672 3.47L96.784 68.06a2.5 2.5 0 0 0 3.471-.673l18.166-26.893a2.5 2.5 0 0 0-.672-3.471l-13.447-9.083-13.447-9.083a2.5 2.5 0 0 0-3.47.672", style: {
  fill: "#e1ebff",
  fill: "color(display-p3 .8833 .923 1)",
  fillOpacity: 1,
  stroke: "#2c1a4f",
  stroke: "color(display-p3 .173 .1028 .3083)",
  strokeOpacity: 1
} })), /* @__PURE__ */ React.createElement("g", { mask: "url(#b)" }, /* @__PURE__ */ React.createElement("path", { fill: "#577ee4", stroke: "#577ee4", strokeLinecap: "round", strokeLinejoin: "round", d: "M70.177 12.909 87.66 26.334a1 1 0 0 1 .184 1.402L74.418 45.218a1 1 0 0 1-1.402.184L55.534 31.977a1 1 0 0 1-.184-1.402l13.425-17.482a1 1 0 0 1 1.402-.184", style: {
  fill: "#577ee4",
  fill: "color(display-p3 .3397 .4954 .8958)",
  fillOpacity: 1,
  stroke: "#577ee4",
  stroke: "color(display-p3 .3397 .4954 .8958)",
  strokeOpacity: 1
} })), /* @__PURE__ */ React.createElement("path", { fill: "#577ee4", stroke: "#577ee4", strokeLinecap: "round", strokeLinejoin: "round", d: "m68.208 50.536-10.88-18.844a1 1 0 0 0-1.21-.44L45.15 35.268a1 1 0 0 0-.425.3l-3.021 3.628a1 1 0 0 0-.101 1.134L52.54 59.574a1 1 0 0 0 1.37.372l13.931-8.044a1 1 0 0 0 .366-1.366", style: {
  fill: "#577ee4",
  fill: "color(display-p3 .3397 .4954 .8958)",
  fillOpacity: 1,
  stroke: "#577ee4",
  stroke: "color(display-p3 .3397 .4954 .8958)",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#ebdeff", d: "m69.138 46.28-15.25-26.414a1 1 0 0 0-1.367-.366l-7.577 4.375-7.578 4.375A1 1 0 0 0 37 29.616L52.25 56.03a1 1 0 0 0 1.366.366l15.155-8.75a1 1 0 0 0 .367-1.366", style: {
  fill: "#ebdeff",
  fill: "color(display-p3 .9235 .8708 1)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#9462ff", d: "m53.454 20.116 15.25 26.414.867-.5-15.25-26.414zm15.067 27.097-15.155 8.75.5.866 15.155-8.75zM52.683 55.78l-15.25-26.414-.866.5 15.25 26.414zM37.616 28.683l7.578-4.375-.5-.866-7.578 4.375zm7.578-4.375 7.577-4.375-.5-.866-7.577 4.375zm-7.761 5.058a.5.5 0 0 1 .183-.683l-.5-.866a1.5 1.5 0 0 0-.55 2.049zm15.933 26.597a.5.5 0 0 1-.683-.183l-.866.5a1.5 1.5 0 0 0 2.049.549zm15.338-9.433a.5.5 0 0 1-.183.683l.5.866a1.5 1.5 0 0 0 .55-2.05zM54.321 19.616a1.5 1.5 0 0 0-2.05-.549l.5.866a.5.5 0 0 1 .683.183z", style: {
  fill: "#9462ff",
  fill: "color(display-p3 .5807 .3833 1)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#577ee4", stroke: "#577ee4", strokeLinecap: "round", strokeLinejoin: "round", d: "M95 65.5c0 8.837-7.163 16-16 16s-16-7.163-16-16 7.163-16 16-16 16 7.163 16 16", style: {
  fill: "#577ee4",
  fill: "color(display-p3 .3397 .4954 .8958)",
  fillOpacity: 1,
  stroke: "#577ee4",
  stroke: "color(display-p3 .3397 .4954 .8958)",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#f8bcf2", d: "M92 62.5c0 8.837-7.163 16-16 16s-16-7.163-16-16 7.163-16 16-16 16 7.163 16 16", style: {
  fill: "#f8bcf2",
  fill: "color(display-p3 .9708 .7362 .9474)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#f371e6", d: "M76 78c8.56 0 15.5-6.94 15.5-15.5h1C92.5 71.613 85.113 79 76 79zm0 1c-9.113 0-16.5-7.387-16.5-16.5h1C60.5 71.06 67.44 78 76 78zm0-32c-8.56 0-15.5 6.94-15.5 15.5h-1C59.5 53.387 66.887 46 76 46zm15.5 15.5C91.5 53.94 84.56 47 76 47v-1c9.113 0 16.5 7.387 16.5 16.5z", style: {
  fill: "#f371e6",
  fill: "color(display-p3 .9542 .4413 .9029)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#fff4bf", d: "M71.634 42.558 54.153 29.133a1 1 0 0 1-.184-1.402l6.712-8.741 6.712-8.741a1 1 0 0 1 1.402-.184l8.741 6.712 8.741 6.712a1 1 0 0 1 .184 1.403L73.037 42.374a1 1 0 0 1-1.403.184", style: {
  fill: "#fff4bf",
  fill: "color(display-p3 1 .9569 .749)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#fed044", d: "M54.457 28.736 71.94 42.161l-.61.793L53.849 29.53zM72.64 42.07l13.425-17.482.793.61-13.425 17.481zm13.332-18.183-8.74-6.712.609-.793 8.74 6.712zm-8.74-6.712L68.49 10.46l.609-.793 8.74 6.713zm-9.442-6.62-6.713 8.74-.793-.609 6.712-8.74zm-6.713 8.74-6.712 8.741-.793-.609 6.712-8.74zM71.94 42.161a.5.5 0 0 0 .701-.092l.793.609a1.5 1.5 0 0 1-2.103.276zM53.848 29.53a1.5 1.5 0 0 1-.276-2.104l.793.61a.5.5 0 0 0 .092.7zm14.643-19.07a.5.5 0 0 0-.701.092l-.794-.609a1.5 1.5 0 0 1 2.104-.276zm17.574 14.126a.5.5 0 0 0-.093-.701l.61-.793a1.5 1.5 0 0 1 .276 2.103z", style: {
  fill: "#fed044",
  fill: "color(display-p3 .9961 .8157 .2667)",
  fillOpacity: 1
} })), /* @__PURE__ */ React.createElement("path", { fill: "#577ee4", d: "M86.008 50.378c-.51 4.295 2.553 8.231 6.848 8.742 4.295.51 8.196-2.598 8.706-6.894.511-4.295-2.553-8.23-6.848-8.741s-8.196 2.598-8.706 6.893", style: {
  fill: "#577ee4",
  fill: "color(display-p3 .3397 .4954 .8958)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#577ee4", d: "M92.915 58.623c-4.018-.477-6.89-4.162-6.41-8.186l-.994-.118c-.543 4.566 2.713 8.754 7.286 9.297zm-.118.993c4.573.543 8.719-2.764 9.262-7.33l-.993-.119c-.478 4.025-4.133 6.933-8.15 6.456zm1.858-15.635c4.018.478 6.889 4.162 6.411 8.186l.993.118c.543-4.566-2.713-8.753-7.286-9.297zm-8.15 6.456c.477-4.025 4.132-6.933 8.15-6.456l.118-.993c-4.573-.543-8.72 2.765-9.262 7.33z", style: {
  fill: "#577ee4",
  fill: "color(display-p3 .3397 .4954 .8958)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#ffd28d", d: "M84.754 48.215c-.51 4.295 2.553 8.23 6.849 8.741 4.295.51 8.196-2.597 8.706-6.893s-2.553-8.23-6.849-8.741c-4.295-.51-8.195 2.597-8.706 6.893", style: {
  fill: "#ffd28d",
  fill: "color(display-p3 1 .8217 .5542)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#f90", d: "M91.662 56.46c-4.018-.478-6.89-4.162-6.412-8.186l-.993-.118c-.542 4.566 2.714 8.753 7.286 9.297zm-.119.993c4.573.543 8.72-2.765 9.262-7.33l-.993-.119c-.478 4.025-4.133 6.933-8.15 6.456zm1.858-15.635c4.018.478 6.89 4.162 6.411 8.186l.993.118c.543-4.566-2.713-8.754-7.286-9.297zm-8.15 6.456c.478-4.025 4.133-6.933 8.15-6.456l.118-.993c-4.572-.543-8.719 2.764-9.262 7.33z", style: {
  fill: "#f90",
  fill: "color(display-p3 1 .6 0)",
  fillOpacity: 1
} }));
export default SvgCreateAccountImg;
